// extracted by mini-css-extract-plugin
module.exports = {"container":"YesNo_container__j9PwS","logo":"YesNo_logo__1XZIt","SportBuff-container":"YesNo_SportBuff-container__2tlhg"};